<template>
  <div>
    <page-header class="mt-4 mt-md-0 mt-sm-4" :page="headerConfig" />

    <filter-manager
      v-model="selectedFilters"
      :display-advanced="false"
      :filters="filterConfig"
      @academicYear="onAcademicYearChange"
      @search="fetchAnnouncements"
    />

    <custom-separator class="pt-3 my-4" text="Resultados" />

    <announcement-row
      v-for="row in pagination.data"
      :id="row.id"
      :key="row.id"
      :area-id="row.areaId"
      :code="row.code"
      :description="row.description"
      :finish-date="row.finishDate"
      :has-submitted-proposals="row.hasSubmittedProposals"
      :is-proposal-determined="row.isProposalDetermined"
      :name="row.name"
      :publish-date="row.publishDate"
      :status-id="row.status.id"
      @refresh="fetchAnnouncements"
      @view="proposalRedirect"
    />

    <custom-result-not-found
      v-if="!pagination.data"
      text="No cuenta con información disponible."
    />

    <pagination
      v-if="showPagination"
      :data="pagination"
      :show-text="true"
      @pagination-go-page="goToPage"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import CustomSeparator from 'custom-separator';
import AnnouncementRow from './AnnouncementRow.vue';

import {
  getAreas,
  getAnnoncements,
  getPreliminarSearchInitFilters,
} from '@/modules/proposalProcess/api.js';

import storeMixin from '@/shared/mixins/storeGenerator';
const MODULE_NAME = 'ProposalProcessModule';

export default {
  name: 'PreliminarySearch',
  components: {
    PageHeader,
    FilterManager,
    Pagination,
    CustomResultNotFound,
    CustomSeparator,
    AnnouncementRow,
  },
  mixins: [storeMixin],
  data() {
    return {
      moduleName: MODULE_NAME,
      headerConfig: {
        title: 'Proceso de Competencias',
        icon: 'fas fa-city',
        routes: ['Proceso de Competencias'],
      },
      academicYears: [],
      areaOptions: [],
      selectedFilters: {
        academicYear: this.currentAcademicYear(),
        announcementKey: null,
        isFinished: null,
        area: null,
      },
      pagination: {
        data: [],
        pageSize: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    filterConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          class: 'col-md-3',
          options: this.academicYears,
          initialValue: this.selectedFilters.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
        },
        {
          name: 'isFinished',
          component: 'CustomDropDown',
          placeholder: '¿Está finalizado?',
          options: [
            { id: 1, name: 'Si' },
            { id: 2, name: 'No' },
          ],
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-2',
          clearable: true,
        },
        {
          name: 'area',
          component: 'CustomDropDown',
          placeholder: 'Seleccione área',
          options: this.areaOptions,
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3',
          clearable: true,
        },
        {
          name: 'announcementKey',
          component: 'CustomInput',
          class: 'col-md-4',
          placeholder: 'Escriba término clave o número de aviso',
          clearable: true,
          icon: 'fas fa-search color-primary-2',
          leftIcon: true,
        },
      ];
    },
    showPagination() {
      return (
        this.pagination.data.length > 0 &&
        this.pagination.totalItemCount > this.pagination.pageSize
      );
    },
  },
  async created() {
    await this.recoveryData();
  },
  async mounted() {
    await this.fetchInitFilters();
    await this.fetchAnnouncements({ page: this.pagination.currentPage });
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async fetchInitFilters() {
      const { data } = await getPreliminarSearchInitFilters();
      this.areaOptions = data.areas;
      this.academicYears = data.academicYears;

      this.fetchAreaOptions();
    },
    async onAcademicYearChange() {
      this.selectedFilters.area = null;
      this.fetchAreaOptions();
    },
    async fetchAreaOptions() {
      const { data } = await getAreas(this.selectedFilters.academicYear?.id);
      this.areaOptions = data;
    },
    async fetchAnnouncements(model) {
      //Set current Page in 1 when is searching
      //For paging this statment is ignored
      if (model.page == undefined) {
        this.pagination.currentPage = 1;
      }

      let startRowIndex = 1;
      if (this.pagination.currentPage > 1) {
        startRowIndex = this.pagination.currentPage;
      }

      const { data } = await getAnnoncements({
        academicYearId: this.selectedFilters.academicYear.id,
        announcementKey: this.selectedFilters.announcementKey,
        areaId: this.selectedFilters.area?.id,
        isFinished: this.selectedFilters.isFinished?.id,
        pageIndex: startRowIndex,
        pageSize: this.pagination.pageSize,
      });

      this.pagination = {
        ...this.pagination,
        data: data.data,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    proposalRedirect(announcementId, areaId) {
      this.$router.push({
        name: 'ProposalProcess',
        params: {
          id: announcementId,
          areaId: areaId,
          academicYearId: this.selectedFilters.academicYear.id,
        },
      });
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.fetchAnnouncements({ page });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
</style>
